/**
 * Ad configuration — returns the correct ad unit IDs based on platform.
 */

// Production Ad Unit IDs
const IOS_BANNER = "ca-app-pub-9296162428113894/6569611183";
const IOS_INTERSTITIAL = "ca-app-pub-9296162428113894/3943447849";
const IOS_REWARDED = "ca-app-pub-9296162428113894/2492459326";

const ANDROID_BANNER = "ca-app-pub-9296162428113894/1700427883";
const ANDROID_INTERSTITIAL = "ca-app-pub-9296162428113894/5731172237";
const ANDROID_REWARDED = "ca-app-pub-9296162428113894/4096617780";

// Test Ad Unit IDs (fallback for web only)
const TEST_BANNER = "ca-app-pub-3940256099942544/6300978111";
const TEST_INTERSTITIAL = "ca-app-pub-3940256099942544/1033173712";
const TEST_REWARDED = "ca-app-pub-3940256099942544/5224354917";

let cachedPlatform = null;

export async function getPlatform() {
  if (cachedPlatform) return cachedPlatform;
  try {
    const { Capacitor } = await import("@capacitor/core");
    cachedPlatform = Capacitor.getPlatform();
  } catch {
    cachedPlatform = "web";
  }
  return cachedPlatform;
}

export async function getBannerId() {
  const platform = await getPlatform();
  if (platform === "ios") return IOS_BANNER;
  if (platform === "android") return ANDROID_BANNER;
  return TEST_BANNER;
}

export async function getInterstitialId() {
  const platform = await getPlatform();
  if (platform === "ios") return IOS_INTERSTITIAL;
  if (platform === "android") return ANDROID_INTERSTITIAL;
  return TEST_INTERSTITIAL;
}

export async function getAppId() {
  const platform = await getPlatform();
  if (platform === "ios") return "ca-app-pub-9296162428113894~8182580334";
  if (platform === "android") return "ca-app-pub-9296162428113894~3755745585";
  return "";
}

export async function getRewardedVideoId() {
  const platform = await getPlatform();
  if (platform === "ios") return IOS_REWARDED;
  if (platform === "android") return ANDROID_REWARDED;
  return TEST_REWARDED;
}
